<h2>{{ section.title }}</h2>
<div [innerHTML]="section.description"></div>
<h2 i18n="Assessment questions">HEADING_ASSESSMENT_QUESTIONS</h2>
<p
  i18n="This assessment is divided into sections, you can answer any question in any order."
  >PARA_ASSESSMENT_INFORMATION</p>
<p
  i18n="Click Help for more information about a question. Click Notes to save your own comments."
  >PARA_ASSESSMENT_CALL_TO_ACTION</p>
<div class="row">
  <div class="col-sm-1" i18n="ID">HEADING_ID</div>
  <div class="col-sm-3" i18n="Questions">HEADING_QUESTIONS</div>
  <div *ngIf="isRiskFirst()" class="col-sm-{{ sizeRiskRewardCols() }}">
  <div class="row">
  <div class="col-sm-{{ sizeRiskRewardSelect() }}" [class.d-none]="hideRisk()" i18n="Risk">HEADING_RISK</div>
  <div class="col-sm-{{ sizeRiskRewardSelect() }}" [class.d-none]="hideReward()" i18n="Reward">HEADING_REWARD</div>
  </div>
  </div>
  <div *ngIf="!isRiskFirst()" class="col-sm-{{ sizeRiskRewardCols() }}">
  <div class="row">
  <div class="col-sm-{{ sizeRiskRewardSelect() }}" [class.d-none]="hideReward()" i18n="Reward">HEADING_REWARD</div>
  <div class="col-sm-{{ sizeRiskRewardSelect() }}" [class.d-none]="hideRisk()" i18n="Risk">HEADING_RISK</div>
  </div>
  </div>
  <div class="col-sm-2" i18n="Help/Notes">HEADING_HELP_NOTES</div>
  <div class="col-sm-2" i18n="Completed">HEADING_COMPLETED</div>
</div>

<div class="form-group">
  <div *ngFor='let q of questions'>
<app-question [question]="q"></app-question>
  </div>
</div>

